export default "__VITE_ASSET__DRaglGHB__"